export enum idProtocolState {
  // Not sent or expired
  toBeSent = 0,
  pendingApproval = 1,
  // Received and processed but it might be expired.
  acknowledged = 2,
}

// Same as 'idProtocolState' but we split 'acknowledged'
// in 'valid' 'expired' and 'expiringSoon'.
export const idDocumentState = {
  serviceNotAvaiable: '-2',
  notSent: '-1',
  received: '100000000',
  pendingApproval: '100000001',
  rejected: '100000002',
  valid: '100000003',
  expiringSoon: '-3',
  expired: '-4',
} as const;

export type IdDocumentStateType =
  (typeof idDocumentState)[keyof typeof idDocumentState];

export const mapIdDocumentStateToLabel = {
  [idDocumentState.serviceNotAvaiable]: 'lbl.document.serviceNotAvaiable',
  [idDocumentState.notSent]: 'lbl.document.notSent',
  [idDocumentState.received]: 'lbl.document.received',
  [idDocumentState.pendingApproval]: 'lbl.document.pendingApproval',
  [idDocumentState.rejected]: 'lbl.document.rejected',
  [idDocumentState.valid]: 'lbl.document.valid',
  [idDocumentState.expiringSoon]: 'lbl.document.expiringSoon',
  [idDocumentState.expired]: 'lbl.document.expired',
};

// Maps 'userProfile.document.type' to its description
export const mapProfileUserIdToDocumentDescription: Record<string, string> = {
  '1': "Carta d'identità",
  '3': 'Patente di guida',
  '4': 'Passaporto',
  '6': 'Riconoscimento mod. AT',
  '7': 'Riconoscimento mod. BT',
};
